import { render, staticRenderFns } from "./memberNotice.vue?vue&type=template&id=9e2a55fe&scoped=true&"
import script from "./memberNotice.vue?vue&type=script&lang=js&"
export * from "./memberNotice.vue?vue&type=script&lang=js&"
import style0 from "./memberNotice.vue?vue&type=style&index=0&id=9e2a55fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2a55fe",
  null
  
)

export default component.exports